module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"missing":"MISSING","annual":"Annual","quarterly":"Quarterly","monthly":"Monthly"},"de":{"missing":"FEHLEND","annual":"Jährlich","quarterly":"Quartalsweise","monthly":"Monatlich"}}')
  delete Component.options._Ctor
}
